import { render, staticRenderFns } from "./EditLink.vue?vue&type=template&id=1abfdb71&scoped=true"
import script from "./EditLink.vue?vue&type=script&lang=js"
export * from "./EditLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abfdb71",
  null
  
)

export default component.exports